"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _require = require("./autoAnnotate"),
    autoAnnotate = _require.autoAnnotate;

function annotateSingleSeq(_ref) {
  var _seqsToAnnotateById, _annotationsToCheckBy;

  var fullSeq = _ref.fullSeq,
      searchSeq = _ref.searchSeq;

  var fullSeqId = fullSeq.id || "fullSeqId";
  var searchSeqId = searchSeq.id || "searchSeqId";
  var results = autoAnnotate({
    seqsToAnnotateById: (_seqsToAnnotateById = {}, _seqsToAnnotateById[fullSeqId] = _extends({}, fullSeq, {
      id: fullSeqId
    }), _seqsToAnnotateById),
    annotationsToCheckById: (_annotationsToCheckBy = {}, _annotationsToCheckBy[searchSeqId] = _extends({}, searchSeq, {
      id: searchSeqId
    }), _annotationsToCheckBy),
    compareName: false
  });
  if (results && results[fullSeqId]) {
    return {
      matches: results[fullSeqId]
    };
  } else {
    return { matches: [] };
  }
}
module.exports = annotateSingleSeq;